<template>
  <div>
    <div class="body">
      <van-image
        class="topLogo"
        :src="require('../../../../public/image/04/1.png')"
      ></van-image>
      <div class="challengeCount">
        <van-image
          :src="require('../../../../public/image/04/2.png')"
        ></van-image>
        <span>{{ gameStatus.count ? gameStatus.count : 0 }}</span>
        <a
          href="javascript:;"
          @click="
            show = true
            getButton('活動規則')
          "
        >
          <van-image
            :src="require('../../../../public/image/04/3.png')"
          ></van-image>
        </a>
      </div>
      <div class="bodywarp">
        <div class="bannerImageList">
          <van-image
            v-for="item in bannerImageList"
            :key="item"
            class="bannerImage"
            :src="item"
          ></van-image>
        </div>
        <div class="gameImage">
          <van-image
            class="bannerImage"
            :src="require('../../../../public/image/04/5.png')"
          ></van-image>
          <van-image
            class="bannerImage"
            :src="require('../../../../public/image/04/4.png')"
          ></van-image>
        </div>
      </div>
      <div class="footer">
        <div class="leftImage">
          <van-image
            @click="clickLeftImage"
            :src="require('../../../../public/image/04/6.png')"
          ></van-image>
        </div>
        <div class="footerButton">
          <div class="footerImage">
            <van-image
              :src="require('../../../../public/image/04/8.png')"
            ></van-image>
          </div>
          <van-image
            class="footerImage"
            @click="submit"
            :src="require('../../../../public/image/04/9.png')"
          ></van-image>
        </div>
        <div class="rightImage" @click="clickRightImage">
          <van-image
            :src="require('../../../../public/image/04/10.png')"
          ></van-image>
          <van-image
            :src="require('../../../../public/image/04/7.png')"
          ></van-image>
        </div>
      </div>
    </div>
    <ReadmeDialog
      :titleImage="require('../../../../public/image/12/6/4.png')"
      :backgroundImage="require('../../../../public/image/12/6/1.png')"
      :removeImage="require('../../../../public/image/12/6/3.png')"
      :textImage="require('../../../../public/image/12/6/2.png')"
      :visible.sync="show"
      @changeVisible="show = !show"
    />
    <CheckInDialog
      :backgroundImage="require('../../../../public/image/12/6/1.png')"
      :removeImage="require('../../../../public/image/12/6/3.png')"
      :textImage="require('../../../../public/image/12/13/1.png')"
      :visible.sync="showNoMore"
      @changeVisible="showNoMore = !showNoMore"
    />
    <ShareDialog
      :backgroundImage="require('../../../../public/image/12/6/1.png')"
      :removeImage="require('../../../../public/image/12/6/3.png')"
      :textImage="require('../../../../public/image/12/5/1.png')"
      :textImage1="require('../../../../public/image/12/5/2.png')"
      @getStatus="getStatus"
      :visible.sync="showShare"
      @changeVisible="showShare = !showShare"
    />
    <GetRewardsDialog
      :backgroundImage="require('../../../../public/image/12/4/4.png')"
      :removeImage="require('../../../../public/image/12/6/3.png')"
      :titleImage="require('../../../../public/image/12/4/5.png')"
      :textImage="require('../../../../public/image/12/4/1.png')"
      :textImage1="require('../../../../public/image/12/4/2.png')"
      :visible.sync="showGetRewards"
      @getStatus="getStatus"
      :imgid="imgid"
      @submit="submit"
      @changeVisible="showGetRewards = !showGetRewards"
    />
    <SimpleDialog
      :backgroundImage="require('../../../../public/image/12/8/1.png')"
      :removeImage="require('../../../../public/image/12/8/3.png')"
      :textImage="require('../../../../public/image/12/8/2.png')"
      :visible.sync="showEasy"
      @changeVisible="showEasy = !showEasy"
    />
    <RewardListDialog
      v-if="list"
      :list="list"
      :titleImage="require('../../../../public/image/12/1/1.png')"
      :backgroundImage="require('../../../../public/image/12/4/4.png')"
      :removeImage="require('../../../../public/image/12/6/3.png')"
      :visible.sync="showRewardList"
      @showPhoneHandel="$emit('showPhoneHandel')"
      @changeVisible="showRewardList = !showRewardList"
    />
    <VideoDialog
      :visible.sync="showVideo"
      @showGetRewards="showGetRewards = true"
      @changeVisible="showVideo = !showVideo"
    />
  </div>
</template>

<script>
import isMobile from '../../../../utils/isMobile.js'
import ReadmeDialog from '../components/readmeDialog/index.vue'
import CheckInDialog from '../components/checkInDialog/index.vue'
import ShareDialog from '../components/shareDialog/index.vue'
import GetRewardsDialog from '../components/getRewardsDialog/index.vue'
import SimpleDialog from '../components/simpleDialog/index.vue'
import RewardListDialog from '../components/rewardListDialog/index.vue'
import VideoDialog from '../components/videoDialog/index.vue'
import browser from '../../../../utils/browser.js'

import getData from '../../../../utils/request/request'
import getButton from '../../../../utils/getButton'

import { Toast } from 'vant'
import { mapGetters } from 'vuex'

export default {
  components: {
    ReadmeDialog,
    CheckInDialog,
    ShareDialog,
    GetRewardsDialog,
    SimpleDialog,
    RewardListDialog,
    VideoDialog
  },
  computed: {
    ...mapGetters(['phone', 'gameStatus'])
  },
  data() {
    return {
      browser: browser(),
      show: false,
      showNoMore: false,
      showShare: false,
      showGetRewards: false,
      showEasy: false,
      showRewardList: false,
      showVideo: false,
      imgid: '1',
      isMobile: isMobile(),
      list: null,
      bannerImageList: [
        require('../../../../public/image/04/1/1.png'),
        require('../../../../public/image/04/1/2.png'),
        require('../../../../public/image/04/1/3.png'),
        require('../../../../public/image/04/1/4.png'),
        require('../../../../public/image/04/1/5.png')
      ]
    }
  },
  methods: {
    getButton(val) {
      getButton(val)
    },
    scrollIntoView(val) {
      this.$emit('scrollIntoView', val)
    },
    async clickLeftImage() {
      getButton('獎勵查詢')
      let Api = {
        url: '/api/get_giftlist',
        type: 'post'
      }
      let form = {
        phone: this.phone
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        this.list = res.list
        this.showRewardList = true
      } else {
        switch (res.msg) {
          case '請先完成手機預約':
            this.$emit('showPhoneHandel')
            break
          default:
            Toast(res.msg)
            break
        }
      }
    },
    async submit() {
      getButton('挑戰')
      let Api = {
        url: '/api/send_slmgift',
        type: 'post'
      }
      let form = {
        phone: this.phone
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        this.$emit('getStatus')
        this.imgid = res.imgid
        this.showVideo = true
      } else {
        switch (res.msg) {
          case '今日次數已用完':
            this.$emit('showShowCheck')
            break
          case '請稍後重試':
            Toast(res.msg)
            break
          case '請先完成手機預約':
            this.$emit('showPhoneHandel')
            break
          case '禮包碼已領完':
            Toast(res.msg)
            break
          case '挑戰次數已用完':
            this.showNoMore = true
            break
          case '立即分享':
            this.showShare = true
            break
          default:
            break
        }
      }
    },
    getStatus() {
      this.$emit('getStatus')
    },
    async share_slm() {
      let Api = {
        url: '/api/share_slm',
        type: 'post'
      }
      let form = {
        utm: this.$route.query.utm_source ? this.$route.query.utm_source : '',
        phone: this.phone
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        this.$emit('getStatus')
        const url = encodeURIComponent(
          'https://www.lingluk.com/crossgate.tw/prereg'
        )
        const facebook = `https://www.facebook.com/sharer/sharer.php?u=${url}`
        if (this.browser.iPhone) {
          window.location.href = facebook
        } else if (this.browser.android) {
          window.open(facebook)
        } else {
          window.open(facebook)
        }
      } else {
        switch (res.msg) {
          case '請先完成手機預約':
            this.$emit('showPhoneHandel')
            break
          case '禮包碼已領完':
            this.$emit('showShowCheck')
            break
          default:
            Toast(res.msg)
            break
        }
      }
    },
    async clickRightImage() {
      getButton('FB分享')
      await this.share_slm()
      // const _this = this
      // setTimeout(() => {
      //   FB.ui(
      //     {
      //       display: 'popup',
      //       method: 'share_open_graph',
      //       action_type: 'og.likes',
      //       action_properties: JSON.stringify({
      //         object: 'https://www.lingluk.com/crossgate.tw/prereg'
      //       })
      //     },
      //     function (response) {
      //       if (!response || response.error_message) {
      //         Toast('分享失败')
      //       } else {
      //         _this.share_slm()
      //       }
      //     }
      //   )
      // }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes heartbeat1 {
  0% {
    transform: translateY(0rem);
  }
  50% {
    transform: translateY(1rem);
  }
  100% {
    transform: translateY(0rem);
  }
}

.body {
  &::before {
    content: '';
    display: table;
  }
  width: 100%;
  // height: 100vh;
  background: url(../../../../public/image/10/04.jpg) no-repeat;
  background-size: 100% 100%;
  position: relative;
  .topLogo {
    display: block;
    width: 80%;
    margin: 0 auto;
    margin-top: 30px;
  }
  .challengeCount {
    text-align: center;
    line-height: 12px;
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;
    /deep/ .van-image {
      width: 30%;
      vertical-align: middle;
    }
    span {
      vertical-align: middle;
      font-size: 22px;
      color: #fff;
      font-family: 'MyOTFFont', sans-serif;
      font-weight: 550;
      text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,
        1px 1px 0 black; /* 上下左右四个方向的阴影，颜色为蓝色 */
    }
    a {
      position: absolute;
      color: black;
      right: 4rem;
      width: 10%;
      /deep/ .van-image {
        width: 100%;
        vertical-align: middle;
      }
    }
  }
  .bodywarp {
    .bannerImageList {
      position: relative;
      height: 180px;
      .bannerImage:nth-child(1) {
        position: absolute;
        top: 10%;
        left: 25%;
        width: 20%;
        animation: heartbeat1 2s ease infinite;
      }
      .bannerImage:nth-child(2) {
        position: absolute;
        top: 50%;
        left: 5%;
        width: 25%;
        animation: heartbeat1 2s ease infinite;
      }
      .bannerImage:nth-child(3) {
        position: absolute;
        top: 5%;
        left: 55%;
        width: 22%;
        animation: heartbeat1 2s ease infinite;
      }
      .bannerImage:nth-child(4) {
        position: absolute;
        top: 25%;
        left: 82%;
        width: 15%;
        animation: heartbeat1 2s ease infinite;
      }
      .bannerImage:nth-child(5) {
        position: absolute;
        top: 50%;
        left: 45%;
        width: 20%;
        animation: heartbeat1 2s ease infinite;
      }
    }
    .gameImage {
      // display: flex;
      // justify-content: space-around;
      position: relative;
      overflow: hidden;
      .bannerImage:nth-child(1) {
        position: absolute;
        width: 25%;
        vertical-align: bottom;
        bottom: 1rem;
        left: 0.5em;
      }
      .bannerImage:nth-child(2) {
        // position: absolute;
        width: 50%;
        vertical-align: bottom;
        float: right;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: space-around;
    padding: 1rem;
    // position: absolute;
    // bottom: 20px;
    width: 100%;
    box-sizing: border-box;
    .footerImage {
      display: block;
      padding: 0.2rem;
    }
    .leftImage {
      width: 20%;
      position: relative;
      /deep/ .van-image {
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
    .footerButton {
      width: 50%;
    }
    .rightImage {
      width: 20%;
      position: relative;
      /deep/ .van-image:nth-child(1) {
        position: absolute;
        top: 0;
        width: 50%;
        right: 0;
      }
      /deep/ .van-image:nth-child(2) {
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/Activity04/index.vue